(function () {
    "use strict";

    angular.module("app").controller("SoUserOrganisationsController", SoUserOrganisationsController);

    SoUserOrganisationsController.$inject = ["$timeout", "controllerDecorator", "soUserOrganisationsApi",];
    function SoUserOrganisationsController($timeout, controllerDecorator, soUserOrganisationsApi,) {
        const vm = Object.assign(this, {
            Load,
            GetItemStyle,
        });
        controllerDecorator.Decorate(vm, []);

        vm.SortType = "Name";
        vm.SortReverse = false;

        vm.HasOrganisations = false;

        vm.PrettyTooltips = () => $timeout(() => $("[data-toggle='tooltip'").tooltip(), 0);

        function Load(request) {
            soUserOrganisationsApi.Search(
                { ReferenceNbr: request.PersonData.ReferenceNbr },
                (result) => {
                    const organisations = result.data;

                    vm.HasOrganisations = organisations.length > 0;

                    if (vm.HasOrganisations) {
                        vm.CurrentOrganisation = organisations.find(org => org.PublicId == request.DossierOrganisationPublicId);
                        vm.OtherOrganisations = organisations.filter(org => org.PublicId != request.DossierOrganisationPublicId);
                    }
                },
                vm.ShowError
            );
        }

        function GetItemStyle(organisation, isCurrentOrganisation) {
            // Current organisation
            if (isCurrentOrganisation)
                return "acceptedScreening";

            if (organisation.IsExpired)
                return "overview-expired";

            if (organisation.WillExpireIn12Months)
                return "overview-expiring";

            return "";
        }
    }
})();
